import * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Feature } from '../feature'
import * as models from '../models'

export const loadOnEnteringOrgChartPage = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    meFeature.contexts.selectors.pageId.asObservable.pipe(
      rxjs.filter(
        pageId => pageId === ents.extra.prebuilt.Page.Id.SummitOrganization,
      ),
      rxjs.switchMap(() =>
        rxjs
          .from(models.OrgChart.Id.ALL)
          .pipe(
            rxjs.map(orgChartId =>
              feature.actions.load
                .from('loadOnEnteringOrgChartPage')
                .create({ orgChartId }),
            ),
          ),
      ),
    ),
)
